import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_48: FaireProductEntity = {
  token: "legacy_prod_abbott-48",
  type: "product",
  name: "Nutcracker Pedestal Cake Plate (Clearance)",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/c2b0c73ab20f5e104d58f25f7683fa10444e7e23a8c65228a4d6349f8b50d477.jpeg",
  priceDollars: 22,
  msrpDollars: 44,
  subcategory: "Serveware",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_kitchen-tabletop"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
